import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import CloudIcon from '@mui/icons-material/Cloud';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import ArticleIcon from '@mui/icons-material/Article';

export const useLogoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  svg: {
    width: 'auto',
    height: 100,
  },
  path: {
    fill: '#7df3e1',
  },
}));

export const tools = [
  {
    url: 'https://backstage.io/docs',
    label: 'Docs',
    icon: <ArticleIcon />,
  },
  {
    url: 'https://glbl-pr-agiledevops-docs-euwe-app.azurewebsites.net/Guides/DevOps-PlayBook/',
    label: 'DevOps Playbook',
    icon: <MicrosoftIcon />,
  },
  {
    url: 'https://glbl-pr-agiledevops-docs-euwe-app.azurewebsites.net/GitHub-Enterprise/1-first-steps/',
    label: 'GitHub Documentation',
    icon: <GitHubIcon />,
  },
  {
    url: 'https://glbl-pr-agiledevops-docs-euwe-app.azurewebsites.net/Azure-DevOps/',
    label: 'Azure DevOps',
    icon: <MicrosoftIcon />,
  },
  {
    url: 'https://glbl-pr-agiledevops-docs-euwe-app.azurewebsites.net/Azure-Cloud-Platform/Azure-Fundamentals/basics/',
    label: 'Azure Cloud Platform',
    icon: <CloudIcon />,
  },
];
